import { setCookie, getCookie } from "./cookies";
import {
  normalizeIDForUrl,
  normalizeUrlForID,
  addToBrowserHistory,
  getAnchorIDFromUrl,
  getPageFromInfoPopupID,
  playPlyrElement,
  isSmallScreen,
  isScrollable, userAgent, isScrolledToBottom, isScrolledToTop
} from "./helpers";
import { loadPageImages } from "./lazyloading";
import { COOKIE_DURATION, PAGE_DEFAULT_ID } from "./vars";

// Detect user agent and add classes to HTML
userAgent();

$(document).ready(function() {
  const $body = $("body");
  let $lastPlayedVideo;

  /* swipe */
  $(".page-content, .popup-window--size-video").swipe({
    //Generic swipe handler for all directions
    swipe: function(event, direction) {
      if (direction === "up") goToNextSection();
      else if (direction === "down") goToPreviousSection();
    },
    excludedElements: "button, input, select, progress, textarea, a, .noSwipe" // , .popup-window__content
  });

  /* set .page-content height with js to screen height - makes problems in safari when set with css */
  // const $pageContent = $('.page-content');
  // $pageContent.css('height', window.innerHeight || $(window).height());
  // $(window).on('resize', function() {
  //   $pageContent.css('height', window.innerHeight || $(window).height());
  // });

  /* popup window */
  const $coverScreen = $("#cover-screen");
  const $popupWindows = $(".popup-window");

  $popupWindows.each(function() {
    //bind to video 'ended' envet
    const $popup = $(this);
    if (!$popup.hasClass("popup-window--size-video")) return;
    const $video = $popup.find(".plyr-player__video");
    $video.on("ended", event => {
      //move to next section when video ends
      closePopups();
      goToNextSection();
    });
  });

  $(".popup-trigger").on("click", function(e) {
    e.preventDefault();
    const id = $(this).attr("href");
    openPopup($(id));
  });

  $coverScreen.on("click", () => {
    if ($(".popup-window--no-close.active").length === 1) return;
    closePopups(true);
  });

  $(".popup-window__close").on("click", event => {
    closePopups(true);
  });

  $(".popup-window--size-video").on("click", () => {
    const $target = $(event.target);
    //close video popup when clicked inside the popup but outside the video
    if (
      $target.hasClass(".plyr-player") ||
      $target.closest(".plyr-player").length
    ) {
      return;
    }
    closePopups(true);
  });

  function openPopup($popup) {
    $coverScreen.addClass("active");
    if ($popup.hasClass("popup-window--x-zdepth"))
      $coverScreen.addClass("cover-screen--x-zdepth");
    // $popup.css("top", $(window).scrollTop() + $(window).height() / 2);
    $popup.addClass("active");
    if ($popup.hasClass("popup-window--no-close"))
      $coverScreen.addClass("cover-screen--above");
    if ($popup.hasClass("popup-window--cover-dark"))
      $coverScreen.addClass("cover-screen--dark");
    if ($popup.hasClass("popup-window--cover-light"))
      $coverScreen.addClass("cover-screen--light");
    if ($popup.hasClass("popup-window--size-video")) {
      //plyr video player
      const $video = $popup.find(".plyr-player__video");
      if (!$popup.hasClass("popup-window--video-initialized")) {
        if (isSmallScreen() && $video.data("sm-src")) {
          $video.find("source").attr("src", $video.data("sm-src"));
          $video.get(0).load(); //make the video to reload because of the src attribute change
        }
        const player = new Plyr($popup.find(".plyr-player__video").get(0), {
          iconUrl: "/wp-content/themes/mim/plyr/plyr.svg" //"./plyr/plyr.svg"
        });

        $video.on("ready", function() {
          $popup.find('.plyr__control--overlaid svg').replaceWith('<img src="/wp-content/themes/mim/images/play.svg" class="plyr-custom-play" />');
          var where = $(this);
          $(window).keypress(function(ekey) {
            if (ekey.which === 32) {
              console.log('pressed');
              ekey.preventDefault();

              if ($(where).closest('.popup-window').hasClass('active')) {
                var plr_el = $(where).get(0).plyr;
                //if (!plr_el.fullscreen.active) {
                plr_el.togglePlay();
                //}
              }
            }
          });
        });
        
        $popup.addClass("popup-window--video-initialized");
      }
      setPopupVideoHeight($popup, $video);
      playPlyrElement($video);
      $lastPlayedVideo = $video;
    }
  }

  function setPopupVideoHeight($popup, $video) {
    const $root = $video.closest(".plyr-player");
    $video.css("height", "auto");
    $root.removeClass("plyr-player--inline");
    if ($popup.height() < $video.height()) {
      $video.css("height", $popup.height() + "px");
      $root.addClass("plyr-player--inline");
    }
  }

  function closePopups(resetLastPlayedVideo = false) {
    $popupWindows.each(function() {
      //stop popup video
      if (
        !$(this).hasClass("active") ||
        !$(this).hasClass("popup-window--size-video")
      )
        return;
      const plyr = $(this)
        .find(".plyr-player__video")
        .get(0).plyr;
      plyr.fullscreen.exit();

      //in case native players exit fullscreen not with plyr
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
      
      //when fullscreen plyr.pause() doesn't seem to be reliable, setTimeout fixes it
      setTimeout(() => {
        plyr.pause();
      }, 0);
    });
    if (resetLastPlayedVideo) $lastPlayedVideo = null;
    $popupWindows.removeClass("active");
    $coverScreen.removeClass(
      "active cover-screen--above cover-screen--dark cover-screen--light cover-screen--x-zdepth"
    );
  }

  // $(window).on("resize", () => {
  //   const $activePopup = $(".popup-window.active");
  //   if ($activePopup.length)
  //     $activePopup.css("top", $(window).scrollTop() + $(window).height() / 2);
  // });

  //menu open/close
  const $navMain = $("#nav-main");
  $(".nav-menu-btn").on("click", () => {
    closePopups();
    closeSideSlides();
    $navMain.addClass("active");
    // navMainFitFont();
  });
  $(".nav-main-close").on("click", () => {
    $navMain.removeClass("active");
  });
  
  //submenu toggle
  (function () {
    const links = [...document.querySelectorAll('#nav-main-content > ul > li > a')];
    const openClass = 'open';

    links.forEach(link => link.addEventListener('click', (e) => {
      const submenu = link.nextElementSibling;
      // const isAccordion = getComputedStyle(submenu).overflow === 'hidden';

      if (!submenu) return;

      e.preventDefault();

      const item = link.closest('li');
      const openItem = links.find(link => link.closest('li').classList.contains(openClass))?.closest('li');
      openItem?.classList.remove(openClass);
      if (item !== openItem) {
        item.classList.add(openClass);
      }
    }));
  })();

  function closeSideSlides() {
    $(".side-slide").removeClass("active");
  }

  //menu fit font to screen size
  // const $navMainContent = $("#nav-main-content");
  // function navMainFitFont() {
  //   $navMainContent.textfill({
  //     maxFontPixels: 100,
  //     innerTag: "ul"
  //   });
  // }

  /* in page navigation */
  const $navInfoButton = $("#nav-info-btn");
  $navInfoButton.on("click", () => {
    closePopups(); //nav links are above screen cover so there might be some popup opened
    const $target = $(
      normalizeUrlForID($(".page-content.active").data("info-popup"))
    );
    if ($target.hasClass("popup-window")) openPopup($target);
    else if ($target.hasClass("side-slide")) $target.addClass("active");
    if ($target.hasClass("add-to-history"))
      addToBrowserHistory(normalizeIDForUrl($target.attr("id")));
  });

  //show contact map
  $(".nav-contact-btn").on("click", () => {
    $("#content-map").addClass("active");
  });

  let $navFilms;
  $("#nav-films-btn").on("click", () => {
    if (!$navFilms) $navFilms = $("#nav-films");
    $navFilms.toggleClass("active");
  });

  let $navDirectors;
  $("#nav-directors-btn").on("click", () => {
    if (!$navDirectors) $navDirectors = $("#nav-directors");
    $navDirectors.toggleClass("active");
  });

  $(".nav-trigger-next").on("click", () => {
    closePopups(true); //nav links are above screen cover so there might be some popup opened
    goToNextSection();
  });

  $(".nav-trigger-open-intro").on("click", (e) => {
    closePopups(true); //nav links are above screen cover so there might be some popup opened
    const openClass = 'intro-open';
    if (document.body.classList.contains(openClass)) {
      goToNextSection();
    } else {
      document.body.classList.add(openClass);
      // Safari "bug": font stays italic
      const btn = e.currentTarget;
      btn.style.fontStyle = 'normal';
      // btn.closest('.container').addEventListener('transitionend', (e) => {
      //   if (e.propertyName !== 'translate') return;
      //   btn.removeAttribute('style');
      // }, { once: true });
    }
  });

  //go to next section on mousewheel / touchmove
  let touchStartY = 0;

  document.addEventListener("touchstart", (e) => {
    touchStartY = e.touches[0].clientY;
  }, { passive: true });

  const handleDocumentScroll = e => {
    const isTouch = e.type === "touchmove";
    const direction = (() => {
      if (isTouch) {
        const delta = touchStartY - e.touches[0].clientY;
        return delta > 0 ? 'down' : 'up';
      } else {
        return e.deltaY > 0 ? 'down' : 'up';
      }
    })();

    const deltaY = isTouch
      ? touchStartY - e.touches[0].clientY
      : e.deltaY;

    const $target = $(e.target);
    const $container = $target.closest(".popup-window, .side-slide");
    const popupContent = $container[0]?.querySelector('.popup-window__content');

    if (
      $container.length &&
      (
        $container.hasClass("side-slide") ||
        $container.hasClass("disable-section-scroll")
        // || (
        //   isScrollable(popupContent) &&
        //   (
        //     (direction === 'down' && !isScrolledToBottom(popupContent)) ||
        //     (direction === 'up' && !isScrolledToTop(popupContent))
        //   )
        // )
      )
    ) {
      return; // Let user scroll the popup
    }

    if (Math.abs(deltaY) > 10) {
      e.preventDefault(); // Block section scroll when not needed
      if (direction === 'down') {
        goToNextSection();
      } else {
        goToPreviousSection();
      }
    }
  };

  // const handleDocumentScrollDebounced = debounce(
  //   handleDocumentScroll,
  //   100,
  //   true
  // );

  // $(document).on("wheel", handleDocumentScroll);
  document.addEventListener("wheel", handleDocumentScroll, { passive: false });
  // document.addEventListener("touchmove", handleDocumentScroll, { passive: false });
  
  const $sideSlides = $(".side-slide");
  $(".nav-trigger").on("click", function(e) {
    closePopups(); //nav links are above screen cover so there might be some popup opened
    e.preventDefault();
    $sideSlides.removeClass("active"); //hide side menus
    const targetID = normalizeUrlForID($(this).attr("href"));
    const $target = $(targetID);
    if ($target.hasClass("page-content")) {
      swapPages($target, $(this).data("source-category"));
      // autoplay video if user comes from .card-grid (nav with preview cards)
      if (e.currentTarget.closest('.card-grid') || e.currentTarget.classList.contains('click-autoplay')) {
        $target.find('.popup-trigger').click();
      }
    } else if ($target.hasClass("side-slide")) {
      $target.addClass("active");
      if ($target.hasClass("add-to-history"))
        addToBrowserHistory(normalizeIDForUrl($target.attr("id")));
    } else {
      $target.addClass("active");
    }
    
    // page with featured image - push side controls down
    if ($target.find('.content-info__featured-image').length > 0) {
      $target[0].addEventListener('transitionend', (e) => {
        if (e.propertyName !== 'transform') return;
        $target[0].style.setProperty('--side-btn-offset', `0px`); // reset before getting top offset
        const contentTop = $('.content-info__content-header', $target)[0].getBoundingClientRect().top;
        const $closeBtns = $('.side-slide__close', $target);
        const closeTop = $closeBtns[0].getBoundingClientRect().top;
        $target[0].style.setProperty('--side-btn-offset', `${contentTop - closeTop - 20}px`); // 20 ~ letter spacing
      }, { once: true });
    }
  });
  
  $(".side-slide__close").on("click", function() {
    const $target = $(this).closest(".side-slide");
    $target.removeClass("active");
    if ($target.hasClass("add-to-history"))
      addToBrowserHistory(
        normalizeIDForUrl($(".page-content.active").attr("id"))
      );
    if (
      $(this).hasClass("side-slide__close--resume-video") &&
      $lastPlayedVideo &&
      $lastPlayedVideo.length
    ) {
      openPopup($lastPlayedVideo.closest(".popup-window"));
      playPlyrElement($lastPlayedVideo);
    }
    
    if ($target.is('#nav-main')) {
      $target.find('.nav-list__item.open').removeClass('open');
    }
  });

  function goToPreviousSection() {
    if (!isUIAccessible()) return;
    const $pageActive = $(".page-content.active").last(); //if swapPages is in progress, there will be two elements with this selector
    const $pagePrev = getPrevPage($pageActive);
    if ($pagePrev.length === 0) return;
    swapPages($pagePrev, null, "top");

    playPauseVideo($pageActive, $pagePrev);
  }

  function goToNextSection() {
    if (!isUIAccessible()) return;
    const $pageActive = $(".page-content.active").first(); //if swapPages is in progress, there will be two elements with this selector
    let $pageNext = getNextPage($pageActive);
    if ($pageNext.length === 0)
      $pageNext = getFirstPageFromCategory(getPageMainCategory($pageActive));
    if ($pageNext.length === 0) return;
    swapPages($pageNext, $pageActive.data("source-category"));
    
    playPauseVideo($pageActive, $pageNext);
    
    // update 'next' button text
    const $nextBtn = $('#nav-next-btn');
    $nextBtn.text($nextBtn.data('text'));
  }
  
  function playPauseVideo($pageActive, $pageNext) {
    if ($pageActive) {
      const activeVideo = $pageActive[0].querySelector('.section__video');
      if (activeVideo) {
        activeVideo.pause();
      }
    }

    if ($pageNext) {
      const nextVideo = $pageNext[0].querySelector('.section__video');
      if (nextVideo) {
        nextVideo.play();
      }
    }
  }

  function isUIAccessible() {
    return isCorrectScreen();
  }

  function getFirstPageFromCategory(category) {
    let $page = $();
    $(".page-content").each(function() {
      const pageCategories = $(this).data("category");
      if (!pageCategories) return;
      if (pageCategories.split(",").includes(category)) {
        $page = $(this);
        return false; //page found, stop the each loop
      }
    });
    return $page;
  }

  function getNextPage($page) {
    const pageCategory = getPageMainCategory($page);
    let $pageNext = $page.next(".page-content");
    while ($pageNext.length === 1) {
      //loop next pages and find the first with current category
      const pageNextCategories = $pageNext.data("category");
      if (!pageNextCategories) continue;
      if (pageNextCategories.split(",").includes(pageCategory)) break;
      $pageNext = $pageNext.next(".page-content");
    }
    return $pageNext;
  }

  function getPrevPage($page) {
    const pageCategory = getPageMainCategory($page);
    let $pagePrev = $page.prev(".page-content");
    while ($pagePrev.length === 1) {
      //loop previous pages and find the first with current category
      const pagePrevCategories = $pagePrev.data("category");
      if (!pagePrevCategories) continue;
      if (pagePrevCategories.split(",").includes(pageCategory)) break;
      $pagePrev = $pagePrev.prev(".page-content");
    }
    return $pagePrev;
  }

  function getPageMainCategory($page) {
    if ($page.data("source-category")) return $page.data("source-category");
    if ($page.data("category")) return $page.data("category").split(",")[0];
  }

  const $navNextBtn = $("#nav-next-btn");
  function swapPages(
    $pageNext,
    sourceCategory,
    directory = "bottom",
    addToHistory = true
  ) {
    $('.mim-pain--hide-before-dom-ready', $pageNext).removeAttr('style');
    
    if ($pageNext.hasClass("active")) {
      //set source category for the currect page, because that could have changed
      sourceCategory && $pageNext.data("source-category", sourceCategory);
      activatePageCategoryButton($pageNext); //show/hide category button

      //do not swap page with itself
      //also prevents other swaps until the previous is done
      return;
    }
    //reset last played video, bacause it would be on another page
    $lastPlayedVideo = null;

    //set source category for the next page
    sourceCategory && $pageNext.data("source-category", sourceCategory);
    //swap pages
    const $pageActive = $(".page-content.active");

    //set transition for the pages to swap from top or bottom
    $pageActive.addClass("no-transition");
    $pageNext.addClass("no-transition");
    if (directory === "top") {
      $pageActive.addClass("anim-reverse");
      $pageNext.addClass("anim-reverse");
    } else if (directory === "bottom") {
      $pageActive.removeClass("anim-reverse");
      $pageNext.removeClass("anim-reverse");
    }
    $pageActive.get(0).offsetWidth; //rerender the element to reset css transition
    $pageNext.get(0).offsetWidth;
    $pageActive.removeClass("no-transition");
    $pageNext.removeClass("no-transition");

    $pageActive.addClass("unactive");
    $pageNext.addClass("active");

    //elements inside the page trigger transitionend event because it's propagated, so it's important
    //to check the event target and then remove event listener
    const transitionEndHandler = e => {
      if (!$(e.target).hasClass("page-content")) return;
      $pageNext.off("transitionend", transitionEndHandler);
      $pageActive.addClass("no-transition");
      $pageActive.removeClass("active unactive");
      $pageActive.get(0).offsetWidth;
      $pageActive.removeClass("no-transition");
    };
    $pageNext.on("transitionend", transitionEndHandler);

    closePopups(true);
    if (addToHistory) {
      addToBrowserHistory(normalizeIDForUrl($pageNext.attr("id")));
    }
    setupPage($pageNext);
  }

  function setupPage($page) {
    //lazyload for page's big image
    loadPageImages($page);

    activatePageCategoryButton($page); //show/hide category button
    activatePageInfoButton($page); //show/hide info button

    //show/hide navigation buttons
    if ($page.hasClass("page-content--nav-hidden"))
      $body.addClass("nav-hidden");
    else $body.removeClass("nav-hidden");

    //show/hide navigation "next" button
    const hasNextPage = pageHasNextPage($page);
    hasNextPage
      ? $navNextBtn.removeClass("unactive")
      : $navNextBtn.addClass("unactive");
  }

  function pageHasNextPage($page, continueFromTop = true) {
    let $nextPage = getNextPage($page);
    if ($nextPage.length === 0 && continueFromTop)
      $nextPage = getFirstPageFromCategory(getPageMainCategory($page));
    return $nextPage.length === 1 && !$nextPage.is($page);
  }

  let $categoryBtns;
  function activatePageCategoryButton($page) {
    //display corresponding category button, hide others
    let category =
      $page.data("source-category") || $page.data("category-button");
    if (!category && $page.data("category"))
      category = $page.data("category").split(",")[0];

    if (!$categoryBtns) $categoryBtns = $(".nav-side-btn--category");
    $categoryBtns.removeClass("active");
    if (category) {
      const $categoryBtn = $(`#nav-${category}-btn`);
      $categoryBtn.length && $categoryBtn.addClass("active");
    }
  }

  function activatePageInfoButton($page) {
    if ($page.data("info-popup")) $body.removeClass("nav-info-hidden");
    else $body.addClass("nav-info-hidden");
  }

  //switch slide handling
  $(".switch-slide").each(function() {
    const $root = $(this);
    $root.find(".switch-slide__def").on("click", () => {
      $root.addClass("active");
    });
    $root.find(".switch-slide__hover").on("click", () => {
      $root.removeClass("active");
    });
  });

  $(document).on("click", function(e) {
    //close when clicked outside
    const $switchSlide = $(e.target).closest(".switch-slide");
    if ($switchSlide.length) $switchSlide.removeClass("active");
  });

  //navigate on key press
  $(document).on("keydown", e => {
    if (e.keyCode === 38)
      //up
      goToPreviousSection();
    else if (e.keyCode === 40)
      //down
      goToNextSection();
    /*
      else if(e.keyCode === 37) //left
      else if(e.keyCode === 39) //right
      */
  });

  //show/hide share icons
  $(".side-slide__share")
    .on("mouseenter", function() {
      $(this)
        .closest(".content-info")
        .find(".content-share")
        .addClass("active");
    })
    .on("mouseleave", function() {
      $(this)
        .closest(".content-info")
        .find(".content-share")
        .removeClass("active");
    });

  //set initial page based on url hash
  const urlTargetAnchor = getAnchorIDFromUrl();
  setStartingPage(urlTargetAnchor);
  if (!$(".page-content.active").hasClass("page-content--nav-hidden"))
    $body.removeClass("nav-hidden");
  $body.addClass("initial-page-set");

  function setStartingPage(targetAnchor) {
    let $startingPage;
    if (!targetAnchor || targetAnchor === PAGE_DEFAULT_ID) return; //no need to load the default page
    const $startingTarget = $(`#${targetAnchor}`);
    if (!$startingTarget.length) return; //404 screen could be displayed here, or just let it fall back to the default page

    if ($startingTarget.hasClass("page-content"))
      initStartingPage($startingTarget);
    else if ($startingTarget.hasClass("content-info")) {
      //target is popup, so first get page having that popup (if any), activate that page and activate the popup
      $startingPage = getPageFromInfoPopupID($startingTarget.attr("id"));
      if (!$startingPage.length) $startingPage = $(`#${PAGE_DEFAULT_ID}`);
      initStartingPage($startingPage);
      $startingTarget.addClass("active");
    }
    //unrecognized page type, 404 screen could be displayed here, or just let it fall back to the default page
    
    playPauseVideo(null, $startingTarget);

    // page with featured image - push side controls down
    if ($startingTarget.find('.content-info__featured-image').length > 0) {
      $startingTarget[0].style.setProperty('--side-btn-offset', `0px`); // reset before getting top offset
      const contentTop = $('.content-info__content-header', $startingTarget)[0].getBoundingClientRect().top;
      const $closeBtns = $('.side-slide__close', $startingTarget);
      const closeTop = $closeBtns[0].getBoundingClientRect().top;
      $startingTarget[0].style.setProperty('--side-btn-offset', `${contentTop - closeTop - 20}px`); // 20 ~ letter spacing
    }
  }

  async function initStartingPage($page) {
    $('.mim-pain--hide-before-dom-ready', $page).removeAttr('style');
    $(`#${PAGE_DEFAULT_ID}`).removeClass("active");
    $page.addClass("active");
    await loadPageImages($page);
    activatePageCategoryButton($page);
    activatePageInfoButton($page);
  }

  //window orientation has to be landscape on small devices
  // const isCorrectScreen = () => !isMobileScreen() || isLandscape();
  const isCorrectScreen = () => true;

  // if (!isCorrectScreen()) {
  //   openPopup($("#landscape-required-popup"));
  // }

  // $(window).on("orientationchange", function() {
  //   $(window).one("resize", function() {
  //     setTimeout(() => {
  //       if (isCorrectScreen()) {
  //         if ($("#landscape-required-popup.active").length) {
  //           closePopups(true);
  //           checkCookieConsent();
  //         }
  //       } else {
  //         closePopups(true);
  //         openPopup($("#landscape-required-popup"));
  //       }
  //     }, 0);
  //   });
  // });
  
  //cookie consent
  if (isCorrectScreen()) checkCookieConsent();

  function checkCookieConsent() {
    $body.addClass("cookies-confirmed");
    
    return true;
    
    const isCookieConsent = getCookie("cookie-consent");
    if (isCookieConsent) {
      //prolong cookie
      setCookie("cookie-consent", "1", COOKIE_DURATION);
      $body.addClass("cookies-confirmed");
    } else {
      openPopup($("#cookie-consent-popup"));
    }
    $("#cookie-consent-btn").on("click", () => {
      //set cookie
      setCookie("cookie-consent", "1", COOKIE_DURATION);
      $("#cookie-consent-popup").removeClass("popup-window--anim-delay");
      closePopups();
      $body.addClass("cookies-confirmed");
    });
  }

  //madeinmunich.com is dead
  (function() {
    const url = new URL(window.location);
    const path = url.pathname.split("/").pop(); // mim-film.de/madeinmunich
    const queryString = [...url.searchParams.keys()][0]; // mim-film.de/?madeinmunich

    if ([path, queryString].includes('madeinmunich')) {
      openMadeInMunichPopup();
    }
  })();

  function openMadeInMunichPopup() {
    const popup = $("#made-in-munich-popup");
    const closeBtn = $("#made-in-munich-btn");
    const showMimDead = localStorage.getItem('mim-dead') !== '1';

    if (showMimDead) {
      openPopup(popup);
    }

    closeBtn.on("click", () => {
      localStorage.setItem('mim-dead', '1');
      popup.removeClass("active");
    });
  }

  //open/close box openable
  $(".box-openable__head").on("click", function() {
    $(this)
      .parent(".box-openable")
      .toggleClass("active");
  });

  //load new page on history change in browser
  $(window).on("popstate", function(e) {
    if (!isCorrectScreen()) {
      //if sreen is not correct, do not continue, that would close the "your-screen-is-not-correct" popup and make web available
      return;
    }
    closePopups(true);
    closeSideSlides();
    let targetID = getAnchorIDFromUrl();
    if (!targetID) targetID = PAGE_DEFAULT_ID;
    const $target = $(`#${targetID}`);
    if (!$target.length) return;

    if ($target.hasClass("page-content"))
      swapPages($target, null, "top", false);
    //move to target page
    else if ($target.hasClass("content-info")) {
      //target is popup, so first get page having that popup, move to that page and activate the popup
      let $targetPage = getPageFromInfoPopupID($target.attr("id"));
      if (!$targetPage.length) $targetPage = $(`#${PAGE_DEFAULT_ID}`);
      swapPages($targetPage, null, "top", false);
      $target.addClass("active");
    }
  });
  
  //mim logo white/dark colors
  (function() {
    const logo = [...document.querySelectorAll('.static-page .page-logo')];
    if (logo.length < 1) return;

    const logoHeight = logo[0].getBoundingClientRect().height; //parseInt(getComputedStyle(logo).getPropertyValue('--header-height'), 10);

    const settings = {
      selector: '.content-info__featured-image, .content-info__inner-content',
      thresholdRatio: 0,
      IntersectionObserverOptions: {
        root: null,
        rootMargin: `-${logoHeight * .5}px 0px -${window.innerHeight - (logoHeight * .5)}px`,
        threshold: thresholdArray(20)
      }
    };
    const targets = document.querySelectorAll(settings.selector);

    if (!targets) return;

    function callback(entries) {
      entries.forEach(entry => {
        const targetRatio = settings.thresholdRatio;
        const ratio = entry.intersectionRatio;
        const isIntersecting = entry.isIntersecting;

        if (isIntersecting && (ratio >= targetRatio)) {
          if (!entry.target.dataset.logo) return;
          const theme = entry.target.dataset.logo ?? 'dark';
          const page = entry.target.closest('.static-page');
          [...page.querySelectorAll('.page-logo')].forEach(el => el.dataset.theme = theme);
        }
      });
    }

    targets.forEach(target => {
      const targetOptions = {
        rootMargin: settings.IntersectionObserverOptions.rootMargin
      };
      const options = Object.assign(settings.IntersectionObserverOptions, targetOptions);
      const observer = new IntersectionObserver(callback, options);
      observer.observe(target);
    });

    function thresholdArray(steps) {
      return Array(steps + 1)
        .fill(0)
        .map((_, index) => index / steps || 0);
    }
  })();
  
  $body.removeClass("no-transitions"); //there are some class changes during page loading, do not animate them
});
